module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-7-a169dbed0cc24968641014bae8e14d61.jpg";